import styled from 'styled-components';

export default styled.div`
   position: absolute;
   top: 102px;
   left: 48px;
   width: 160px;
   height: 200px;
   overflow: hidden;
   background-image: url("tetris_square_spritesheet.png");
   animation: tetramino-animation 1s linear infinite forwards;
   
   @keyframes tetramino-animation {
     0%, 10% {
       background-position-x: 0px;
       background-position-y: 0px;
     }
     10.01%, 20% {
       background-position-x: -160px;
       background-position-y: 0px;
     }
     20.01%, 30% {
       background-position-x: -320px;
       background-position-y: 0px;
     }
     30.01%, 40% {
       background-position-x: -480px;
       background-position-y: 0px;
     }
     40.01%, 50.00% {
       background-position-x: -640px;
       background-position-y: 0px;
     }
     50.01%, 60% {
       background-position-x: 0px;
       background-position-y: -200px;
     }
     60.01%, 70% {
       background-position-x: -160px;
       background-position-y: -200px;
     }
     70.01%, 80% {
       background-position-x: -320px;
       background-position-y: -200px;
     }
     80.01%, 90% {
       background-position-x: -480px;
       background-position-y: -200px;
     }
     90.01%, 100% {
       background-position-x: -640px;
       background-position-y: -200px;
     }
   }
`;
